import cx from 'clsx';
import * as React from 'react';

import styles from './Indicator.module.scss';

interface IndicatorProps {
  amount: number;
  active: number;
  ref?: any;
}

const Indicator: React.FC<IndicatorProps> = ({ amount, active }) => {
  return amount > 1 ? (
    <ul className={styles.indicatorsWrapper}>
      {Array.from(Array(amount).keys()).map(idx => (
        <li
          data-testid="indicator"
          key={idx}
          className={cx(
            styles.indicator,
            idx === active ? styles.activeIndicator : styles.inactiveIndicator
          )}
        />
      ))}
    </ul>
  ) : null;
};

export default Indicator;
